import React from 'react'
import { CMSContentItemProps } from '../CMSContentItem'
import { Link } from 'gatsby';
import { BsPersonFill } from "react-icons/bs";
import { GatsbyImage, getImage, ImageDataLike } from 'gatsby-plugin-image';
import { DateTime } from 'luxon';
import { BlogPageData } from '../../pages/Blog';

type Props = Omit<CMSContentItemProps, "selectedTransformationId"> & {
    contentData: BlogPageData;
}

export default function BlogItem({ model, content, contentData }: Props) {

    const title = contentData.title;
    const summary = contentData.summary;
    const date = contentData.date;
    const dateTime = DateTime.fromISO(date || '');
    const slug = contentData.slug;
    const author = contentData.author;

    const slugFormatted = slug?.startsWith('/') ? slug : `/${slug}`;

    return (
        <div className='px-4 md:w-1/3 w-full lex flex-col'>
            <Link className='flex flex-col h-full' to={`/blog${slugFormatted}`}>
                <div className="">
                    {contentData.gatsbyImageFile && (
                        <GatsbyImage
                            image={contentData.gatsbyImageFile}
                            alt={contentData.title || ""}
                            style={{
                                width: '100%',
                                height: 'auto',
                                objectFit: 'cover',
                                aspectRatio: '16/9'
                            }}
                        />
                    )}
                    {!contentData.gatsbyImageFile && (
                        <div className='bg-primary' style={{
                            width: '100%',
                            height: '0',
                            paddingTop: '56.25%',
                            position: 'relative'
                        }} />
                    )}
                </div>
                <div className='flex-1 flex flex-col p-4 bg-gray-100 space-y-2'>
                    <h2 className='text-2xl font-bold m-0'>
                        {title}
                    </h2>
                    {summary && (
                        <p className='text-lg'>
                            {summary}
                        </p>
                    )}
                    <div className='flex flex-1 flex-wrap items-end pt-2 space-x-2'>
                        <div>
                            <div className='
                                    flex justify-center items-center
                                    w-7 h-7 rounded-full bg-primary
                                '>
                                <BsPersonFill fontSize={16} />
                            </div>
                        </div>
                        <div className='text-lg flex-1'>
                            {author}
                        </div>
                        <div className='text-md'>
                            {dateTime.toFormat('LLL dd, yyyy')}
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    )
}
